import React from 'react';
import type { Tier } from '../types/tier';
import { tierStyles } from '../utils/tier';
type TierBadgeProps = {
  tier: Tier;
  compact?: boolean;
};
export function TierBadge({
  tier,
  compact = false
}: TierBadgeProps) {
  const Icon = tier.icon;
  return <span className={`inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${tierStyles[tier.id].badge}`} title={`Tier ${tier.level} · ${tier.name}`} data-id="element-633" data-mp="70r9aweyn011">
      <Icon className="size-3" aria-hidden="true" data-id="element-634" data-mp="1zbn3111qnh2" />
      {compact ? <span className="sr-only" data-id="element-635" data-mp="20wggnbmk0dc">{tier.name} tier</span> : tier.name}
    </span>;
}